SC.shopping_bag_page = (function () {
  var api = {};

  // Use shared utility for showing cart discounts
  var showCartDiscounts = function (discountData) {
    SC.checkoutUtils.showDiscounts(discountData, { showCartItemDiscounts: true });
  };

  // Alias shared utilities for local use
  var toggleButtonState = SC.checkoutUtils.toggleButtonState;

  var init = function () {
    handlers();
  };

  var handlers = function () {
    var $container = $('.shopping-bag-container');
    var promoCodeEndpoint = '/checkout/promo-code/';

    // Expand summary on mobile
    $container.on('click', '.js-summary-header', function (e) {
      e.preventDefault();
      var $summaryHeaderEl = $(this);
      var $summaryContainer = $('.js-summary-container');

      if ($summaryContainer.length) {
        $summaryHeaderEl.slideUp(function() {
          $summaryContainer.slideDown();
        });
      }
    });

    // Collapse summary on mobile
    $container.on('click', '.js-collapse-summary', function (e) {
      e.preventDefault();
      var $summaryHeaderEl = $('.js-summary-header');
      var $summaryContainer = $('.js-summary-container');

      if ($summaryContainer.length) {
        $summaryContainer.slideUp(function() {
          $summaryHeaderEl.slideDown();
        });
      }
    });

    $container.on('click', '.sc-giftcard-form .submit', function (e) {
      e.preventDefault();
      var $form = $('.shopping-bag-container .sc-giftcard-form');
      var gcInputsContainer = document.querySelector('.sc-giftcard-form .input-containers form');
      var gcButton = gcInputsContainer.querySelector('button');

      toggleThrobber(true);
      gcButton = toggleButtonState(gcButton, gcInputsContainer);

      $.ajax({
        'url': '/checkout/gift-card/',
        'type': 'post',
        'dataType': 'json',
        'data': {
          'giftCode': $form.find('.gc-number').val(),
          'pin': $form.find('.gc-pin').val(),
          'csrf_token': window.soulcycle.noncePool.pop(),
          'reload': true
        },
        success: function (request) {
          if (request.success) {
            confirmation(false, request.message, undefined, 0);
            window.location.reload();
          } else {
            toggleThrobber(false);
            gcButton = toggleButtonState(gcButton, gcInputsContainer);
            confirmation(false, request.message, undefined, 0);
          }
        },
        error: function (error) {
          toggleThrobber(false);
          gcButton = toggleButtonState(gcButton, gcInputsContainer);

          var message = error.responseJSON.message || 'We experienced an error adding this gift card. Try that again!';
          confirmation(false, message + '<span class="visually-hidden">Use your browser\'s modifier key and \'c\' to access the field.</span>', undefined, 0);
        }
      });
    });

    $container.on('click', '.delete-gift-card', function (e) {
      var $this = $(this);

      e.preventDefault();

      toggleThrobber();
      $.ajax({
        url: '/checkout/gift-card/',
        type: 'DELETE',
        data: JSON.stringify({
          giftCode: $this.data('gift-code'),
          reload: true
        }),
        contentType: 'application/json',
        dataType: 'json',
        success: function (response) {
          if (response.message) {
            confirmation(false, response.message, undefined, 0);
          }
          window.location.reload();
        },
        error: function () {
          toggleThrobber(false);
          confirmation(false, 'We experienced an error removing this gift card. Try that again!');
        }
      });
    });

    // Add promo code
    $container.on('click', '.sc-promo-code-form .submit', function (e) {
      e.preventDefault();

      // Event Data for Promotional Code mParticle Event at Step 1.
      var eventData = {
        'Location': 'Shop',
        'Step': 1,
        'Response': null
      };
      var $form = $('.shopping-bag-container .sc-promo-code-form');
      var promoCodeContainer = document.querySelector('.promo-form-container');
      var promoCodeButton = promoCodeContainer.querySelector('button');
      var promoCodeInput = promoCodeContainer.querySelector('#promo-code-input');

      toggleThrobber(true);
      promoCodeButton = toggleButtonState(promoCodeButton, promoCodeContainer);

      $.ajax({
        'url': promoCodeEndpoint,
        'type': 'post',
        'dataType': 'json',
        'data': {
          'promoCode': $form.find('#promo-code-input').val()
        },
        success: function (response) {
          if (response.success && response.message) {
            confirmation(false, response.message, undefined, 0);
            showCartDiscounts(response);
            promoCodeInput.value = '';
            promoCodeInput.nextElementSibling.classList.remove('floated');
            // Update sticky summary total after checkout summary is refreshed
            eventData.Response = 'Success';
          } else {
            confirmation(false, response.message, undefined, 0);
            toggleButtonState(promoCodeButton, promoCodeContainer);
            eventData.Response = 'Invalid Form';
          }

          // Log mParticle Event - Apply Promotional Code
          SC.analytics.mp.sendEvent('Apply Promotional Code', 'transaction', eventData, 'Step ' + eventData.Step);
          window.location.reload();
        },
        error: function (error) {
          toggleThrobber(false);
          toggleButtonState(promoCodeButton, promoCodeContainer);

          var message = error.responseJSON.message || 'There was a problem applying your code';
          confirmation(false, message + '<span class="visually-hidden">Use your browser\'s modifier key and \'p\' to access the field.</span>', undefined, 0);

          // Log mParticle Event - Apply Promotional Code - Server Error.
          eventData.Response = 'Server Error';
          SC.analytics.mp.sendEvent('Apply Promotional Code', 'transaction', eventData, 'Step ' + eventData.Step);
        }
      });
    });

    // Delete promo code
    $container.on('click', '.applied-promo-message button, .applied-promo-code-container .remove-promo-code', function (e) {
      e.preventDefault();

      var $parent = $(this).parents('.applied-promo-code-container');

      // Event Data for Promotional Code mParticle Event at Step 1.
      var eventData = {
        'Location': 'Shop',
        'Step': 1,
        'Response': null
      };
      var promoCodeName = $parent.data('promo-code');

      toggleThrobber(true);
      $.ajax({
        'url': promoCodeEndpoint,
        'type': 'DELETE',
        'dataType': 'json',
        'data': JSON.stringify({
          promoCode: promoCodeName
        }),
        success: function (response) {
          if (response.success && response.message) {
            confirmation(false, response.message, undefined, 0);
            showCartDiscounts(response);
            // Update sticky summary total after checkout summary is refreshed
            var updatedTotal = $('#estimated-total').text();
            $('.sbag__summary-total .value, .summary-toggle-header .value').text(updatedTotal);

            // Set Response in event Data for mParticle event.
            eventData.Response = 'Success';
          } else {
            eventData.Response = 'Invalid Form';
          }

          // Log mParticle Event - Remove Promotional Code - Success/Invalid Form
          SC.analytics.mp.sendEvent('Remove Promotional Code', 'transaction', eventData, 'Step ' + eventData.Step);
          window.location.reload();
        },
        error: function () {
          toggleThrobber(false);
          confirmation(false, 'There was an issue removing that code. <span class="visually-hidden">Use your browser\'s modifier key and \'p\' to access the field.</span>', undefined, 0);

          // Log mParticle Event - Remove Promotional Code - Server Error
          eventData.Response = 'Server Error';
          SC.analytics.mp.sendEvent('Remove Promotional Code', 'transaction', eventData, 'Step ' + eventData.Step);
        }
      });
    });

    $container.on('change', '.shipping-method-form select', function () {
      var $form = $(this).closest('form');
      $form.submit();
    });

    /**
     * Old GA Checkout Event - Shopping Bag page view
     * Deprecated: Will be removed soon.
     *
     * @returns {void}
     */
    window.onload = function () {
      SC.analytics.ga.sendEvent('shop', 'checkout', 'shopping_bag_page');
    };


    $container.on('change', '.item-quantity select', function () {
      if (!$(this).closest('.bag-item-row').hasClass('gift-card')) {
        /**
         * mParticle event tracking - bag - remove item
         */
        var $form = $(this).closest('form');
        var $item = $(this).closest('.bag-item-row');
        var itemData = $item.find('.item-remove').data();
        var category = itemData.category;
        var newItemQuantity = parseInt($form.find('.item-quantity option:selected').text(), 0);
        var itemQuantity = newItemQuantity;
        var eventName;
        var itemTitle;
        var product;

        // Get the item title, sku and base sku, then create the product
        itemTitle = SC.utils.getProductTitle(category, itemData.size, itemData.productTitle);
        var baseSku = SC.utils.getBaseSku(category, itemData.sku, itemData.productSlug);
        var sku = SC.utils.getSku(category, itemData.sku, itemData.size);
        var attrs = {'Base Sku': baseSku};

        product = SC.analytics.mp.createProduct(
          itemTitle,
          sku,
          itemData.productPrice.substr(1),
          Math.abs(itemQuantity).toString(),
          category,
          attrs
        );

        if (parseInt(itemQuantity, 0) < 0) {
          eventName = 'RemoveFromCart';
        } else {
          eventName = 'AddToCart';
        }

        // Set the currency code then log the mParticle eCommerce event and submit the form.
        SC.analytics.mp.setCurrencyCode($item.data('currency-code'));
        SC.analytics.mp.logProductEvent(eventName, product, {'Location': 'Shopping Bag'});
        $form.submit();
      }
    });

    $container.on('click', '.bag-item-row .item-remove', function () {
      var genericBagRemoveErrorMessage = 'We experienced an error removing this item from your bag. Try that again!';
      var $itemData = $(this);
      var $item = $itemData.closest('.bag-item-row');
      var itemId = $item.data('id');
      var itemQuantity = $item.data('quantity');

      toggleThrobber(true);

      $.ajax({
        url: '/shop/remove-from-bag/',
        dataType: 'json',
        data: {
          item: itemId,
          quantity: itemQuantity,
          csrf_token: window.soulcycle.noncePool.pop()
        },
        method: 'POST',
        success: function (data) {
          if (data.success) {
            /**
             * mParticle event tracking - bag - remove item
             */
            var itemPrice = $itemData.data('product-price');
            var slug = $itemData.data('product-slug');
            var category = $itemData.data('category');
            var size = $itemData.data('size');
            var itemTitle = SC.utils.getProductTitle(
              category,
              size,
              $itemData.data('product-title')
            );
            var baseSku = SC.utils.getBaseSku(category, $itemData.data('sku'), slug);
            var sku = SC.utils.getSku(category, $itemData.data('sku'), size);
            var attrs = {'Base Sku': baseSku};
            var product = SC.analytics.mp.createProduct(
              itemTitle,
              sku,
              itemPrice,
              itemQuantity.toString(),
              null,
              attrs
            );

            // Set the currency code for the mParticle eCommerce event then log the event and reload.
            SC.analytics.mp.setCurrencyCode($item.data('currency-code'));
            SC.analytics.mp.logProductEvent('RemoveFromCart', product, {'Location': 'Shopping Bag'});
            window.location.reload();
          } else {
            toggleThrobber(false);
            confirmation(undefined, genericBagRemoveErrorMessage);
          }
        },
        error: function () {
          toggleThrobber(false);
          confirmation(undefined, genericBagRemoveErrorMessage);
        }
      });
    });

    $container.on('click', '#checkout-button', function (e) {
      var itemCheckbox = $('#agree-checkbox');
      var termsAndCondCheckbox = $('#agree-renew-tc-checkbox');
      if (
        (itemCheckbox.length === 0 || (itemCheckbox.length && itemCheckbox.prop('checked'))) &&
        (termsAndCondCheckbox.length === 0 || (termsAndCondCheckbox.length && termsAndCondCheckbox.prop('checked')))
      ) {
        logCheckoutResponse(1, 'Success', null);
      } else {
        e.preventDefault();
        confirmation(false, 'Please agree to the Terms & Conditions <span class="visually-hidden">Use your browser\'s modifier key and \'r\' to access the field.</span>', undefined, 0);
        itemCheckbox.focus();
        logCheckoutResponse(1, 'Invalid Form');
      }
    });

    $container.on('blur', '#promo-code-input, #giftcard-number, #giftcard-pin', function (e) {
      var label = e.target.nextElementSibling;

      if (e.target.value !== '') {
        label.classList.add('floated');
      } else {
        label.classList.remove('floated');
      }
    });

    var promoCodeForm = document.getElementsByClassName('sc-promo-code-form')[0];

    if (promoCodeForm) {
      var promoCodeFormTitle      = document.getElementsByClassName('expandable-title')[0];
      var promoCodeFormExpandable = promoCodeForm.getElementsByClassName('expandable-content')[0];
      var promoCodeInput          = document.querySelector('#promo-code-input');

      var handleExpandPromoCode = SC.checkoutUtils.createExpandHandler(promoCodeFormTitle, promoCodeFormExpandable, promoCodeInput);

      var handleActivatePCButton = SC.checkoutUtils.createPromoCodeButtonHandler('.promo-form-container');

      promoCodeFormTitle.addEventListener('click', handleExpandPromoCode);
      promoCodeFormTitle.addEventListener('keypress', handleExpandPromoCode);
      if (promoCodeInput) promoCodeInput.addEventListener('keyup', handleActivatePCButton);
    }

    var gcForm = document.querySelector('.shopping-bag-container .sc-giftcard-form');

    if (gcForm) {
      var gcNumber = gcForm.querySelector('.gc-number');
      var gcPin = gcForm.querySelector('.gc-pin');
      var gcFormTitle = gcForm.querySelector('.expandable-title');
      var gcFormExpandable = gcForm.querySelector('.expandable-content');

      var handleExpandGCForm = SC.checkoutUtils.createExpandHandler(gcFormTitle, gcFormExpandable, gcNumber);
      var handleActivateGCButton = SC.checkoutUtils.createGiftCardButtonHandler(gcForm, gcNumber, gcPin, '.input-containers form');

      if (SC.utils.getCurrentPlatform() !== 'iOS') {
        gcFormTitle.addEventListener('click', handleExpandGCForm);
        gcFormTitle.addEventListener('keypress', handleExpandGCForm);
      } else {
        handleExpandGCForm({type: 'iOSExpansion'});
      }

      if (gcNumber) gcNumber.addEventListener('keyup', handleActivateGCButton);
      if (gcPin) gcPin.addEventListener('keyup', handleActivateGCButton);
    }

    // mParticle LogEvent - Click Continue Shopping - Shopping Bag Page
    $('.continue-shopping').on('click keyup', function (e) {
      if (!SC.utils.ui.handleKeyupEvent(e)) {
        return;
      }

      var eventData = {
        'Location': 'Shop',
        'Step': 1
      };

      SC.analytics.mp.logEvent('Click Continue Shopping', 'navigation', eventData);
    });
  };

  function logCheckoutResponse(step, response, paymentMethod, redirect) {
    try {
      var $cartItems = $('.bag-item-row');
      var eventData = {
        'Subtotal': $('.estimated-total').data('total'),
        'Location': 'Shop',
        'Gift Card Applied': $('.gift-card-list').length > 0,
        'Response': response
      };
      var products = [];

      $cartItems.each(function (index, cartItem) {
        var $item = $(cartItem);
        var itemData = $item.data();
        var productData = $item.find('.item-remove').data();
        var category = productData.category;
        var productName = SC.utils.getProductTitle(
          category,
          productData.size,
          productData.productTitle
        );
        var baseSku = SC.utils.getBaseSku(category, productData.sku, productData.productSlug);
        var sku = SC.utils.getSku(category, productData.sku, productData.size);
        var attrs = {'Base Sku': baseSku};
        var product = SC.analytics.mp.createProduct(
          productName,
          sku,
          productData.productPrice,
          itemData.quantity,
          null,
          attrs
        );

        products.push(product);
      });

      // First clear the virtual cart.
      // Then, set the currency code.
      // Finally, update with the current cart items so its update to date for the rest of checkout.log
      SC.analytics.mp.clearCart();
      SC.analytics.mp.setCurrencyCode($('#checkout-button').data('currency-code'));
      SC.analytics.mp.updateCart(products);

      // Then log the Step 1 checkout event.
      SC.analytics.mp.logCheckout(step, paymentMethod, eventData);
    } catch (e) {
      console.log('There was an error logging the checkout response mp event. Error: ' + e.message);
    }

    // If there was a redirect, change the window location.
    if (redirect) {
      window.location.href = redirect;
    }
  }

  // Initialize common form fields (browser info, affiliate info)
  SC.checkoutUtils.initFormFields();

  init();
  return api;
})();
